<template>
    <div class="view-container">
        <div v-if="parametresType && isMobile" class="mobile-header-block">
          <div class="back-button-wrapper" @click="router.push('/Analytics')">
            <LeftOutlined class="back-button" />
          </div>
          <h2>{{ analyticsHeader ?? 'Аналитика' }}</h2>
        </div>
          <div v-if="parametresType" class="analytic-form__options">
            <component
              @reportRequest="makeChart"
              v-bind:is="parametresType"
            ></component>
          </div>
          <div class="analytic-form__charts w-full">
            <div
              v-if="reportRequest && !reportData"
              class="
                w-full
                flex
                justify-content-center
                align-item-center
                preloader
              "
            >
              <preloader />
            </div>
            <div class="card" v-else-if="reportData">
              <analytics-groups-tags />
              <component :groupId="groupId" v-bind:is="reportType"></component>
            </div>
          </div>
    </div>
</template>

<script>
import { onBeforeMount, onBeforeUnmount, ref } from "@vue/runtime-core";
import {useRoute, useRouter} from "vue-router";
import { computed } from "@vue/runtime-core";
import BaseReportParametres from "../../feature/analytics/report-parameters/BaseReportParametres.vue";
import BaseReport from "../../feature/analytics/reports/BaseReport.vue";
import Preloader from "@/components/Technical/Preloader.vue";
import GroupReportParametres from "../../feature/analytics/report-parameters/GroupReportParametres.vue";
import GroupReport from "../../feature/analytics/reports/GroupReport.vue";
import GeneralDynamicParametres from "../../feature/analytics/report-parameters/GeneralDynamicParametres.vue";
import ReferenceReportParametres from "../../feature/analytics/report-parameters/ReferenceReportParametres.vue";
import ReferenceUsersReportParametres from "../../feature/analytics/report-parameters/ReferenceUsersReportParametres.vue";
import RepeatedReportParametres from "../../feature/analytics/report-parameters/RepeatedReportParametres.vue";
import DemographicReportParametres from "../../feature/analytics/report-parameters/DemographicReportParametres.vue";
import DemographicReport from "../../feature/analytics/reports/DemographicReport.vue";
import { useStore } from "vuex";
import ReferenceUsersReport from "../../feature/analytics/reports/ReferenceUsersReport.vue";
import SummaryTableParametres from "../../feature/analytics/report-parameters/SummaryTableParametres.vue";
import SummaryReport from "../../feature/analytics/reports/SummaryReport.vue";
import GeneralReport from "@/feature/analytics/reports/GeneralReport.vue";
import GeneralReportParameters from "@/feature/analytics/report-parameters/GeneralReportParameters.vue";
import TestingDataReportParameters from "@/feature/analytics/report-parameters/TestingDataReportParameters.vue";
import AnalyticsGroupsTags from "@/feature/analytics/charts/details/GroupTags.vue";
import {LeftOutlined, SearchOutlined} from "@ant-design/icons-vue";
import {onMounted} from "vue";

const reportsParamsDictionary = {
  base: "base-report-parametres",
  group: "group-report-parametres",
  dynamic: "general-dynamic-parametres",
  reference: "reference-users-report-parametres",
  repeated: "repeated-report-parametres",
  demographic: "demographic-report-parametres",
  summary: "summary-table-parametres",
  general: "general-report-parameters",
  testing_data: "testing-data-report-parameters",
};

const reportsDictionary = {
  base: "base-report",
  group: "group-report",
  dynamic: "group-report",
  reference: "reference-users-report",
  repeated: "group-report",
  demographic: "demographic-report",
  summary: "summary-report",
  general: "general-report",
};

const analyticsHeaderDictionary = {
  base: "Общая аналитика для группы респондентов",
  group: "Сравнение групп",
  dynamic: "Аналитика динамики среднего профиля",
  repeated: "Аналитика при повторном тестировании",
  demographic: "Аналитика по демографическим показателям",
  reference: "Эталонный профиль",
  summary: "Общая аналитика",
  general: "Сводная таблица",
  testing_data: "Аналитика",
};

export default {
  components: {
    LeftOutlined,
    SearchOutlined,
    AnalyticsGroupsTags,
    BaseReportParametres,
    BaseReport,
    Preloader,
    GroupReportParametres,
    GroupReport,
    GeneralDynamicParametres,
    ReferenceReportParametres,
    ReferenceUsersReportParametres,
    RepeatedReportParametres,
    DemographicReportParametres,
    DemographicReport,
    ReferenceUsersReport,
    SummaryTableParametres,
    SummaryReport,
    GeneralReportParameters,
    GeneralReport,
    TestingDataReportParameters
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { name } = useRoute().params;
    const parametresType = ref(null),
      reportType = ref(null),
      reportRequest = ref(false),
      groupId = ref(null);
    const reportData = computed(() => store.state.analytics.reportData),
      reportReservedData = computed(
        () => store.state.analytics.reportReservedData
      );
    const currentAnimation = ref("");

    const makeChart = (data) => {
      store.commit("analytics/setReportData", null);
      groupId.value = data.group_id;

      switch (name) {
        case "base":
          store.dispatch("analytics/getBaseReportData", data);
          break;
        case "group":
          store.dispatch("analytics/getGroupReportData", data);
          break;
        case "dynamic":
          store.dispatch("analytics/getGeneralDymanicData", data);
          break;
        case "repeated":
          store.dispatch("analytics/getRepeatedData", data);
          break;
        case "demographic":
          store.dispatch("analytics/getDifferencesSexData", data);
          store.dispatch("analytics/getDifferencesAgeData", data);
          break;
        case "reference":
          groupId.value = data.group_id;
          store.dispatch("analytics/getReferenceUsersData", data);
          break;
        case "summary":
          groupId.value = data.group_id;
          store.dispatch("analytics/getSummaryTable", data);
          break;
        case "general":
          groupId.value = data.group_id;
          store.dispatch("analytics/getGeneralReportTable", data);
          break;
        case "testing_data":
          break;
      }
      reportRequest.value = true;
    };

    const isMobile = ref(window.innerWidth <= 768)
    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    const analyticsHeader = computed(() => store.state.analytics.analyticsHeader);

    onBeforeMount(() => {
      parametresType.value = reportsParamsDictionary[name];
      reportType.value = reportsDictionary[name];
      store.commit("analytics/setAnalyticsHeader", analyticsHeaderDictionary[name]);
    });

    onBeforeUnmount(() => {
      store.commit("analytics/setReportData", null);
      store.commit("analytics/setAnalyticsHeader", null);
    });

    return {
      parametresType,
      reportType,
      reportRequest,
      reportData,
      reportReservedData,
      makeChart,
      groupId,
      currentAnimation,
      isMobile,
      analyticsHeader,
      router
    };
  },
};
</script>

<style scored lang="scss">
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.2s ease-out;
}

.slide-right-leave-to,
.slide-right-enter-from {
  opacity: 0;
  transform: translateX(1000px);
}
.preloader {
  min-height: 200px;
}

.back-analytics {
  i {
    margin-right: 5px;
  }
}

.card-header {
  padding-bottom: 0;
}

.card-body {
  padding-top: 0;
}

.back-btn {
  display: flex;
  padding-bottom: 20px;
}

.hide {
  animation: slide-in-left 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) reverse;
}
.show {
  animation: slide-in-left 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  65% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    opacity: 1;
  }
}

.analytic-form__options {
  .label {
    font-size: 14px;
    color: var(--grey-text);
    margin-bottom: 4px;
  }
}

.ant-alert-message p {
  margin-bottom: 0 !important;
}

.back-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: #FFFFFF;
  border-radius: 25%;
  cursor: pointer;
}

.mobile-header-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 8px;
    align-items: flex-start;
  }
}

.mobile-header-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}
</style>
